import {
  PersonaliseEvent,
  SelectContentEvent,
} from '@moonpig/launchpad-analytics'
import { BRAND_LABEL } from '@moonpig/web-core-brand/config'

export const personaliseEvent = PersonaliseEvent()
  .withEventData({
    action: 'personalise',
    category: 'product action',
    non_interaction: true,
  })
  .withProductData({
    product_brand: BRAND_LABEL.toLowerCase(),
  })

export const leaveItBlankEvent = SelectContentEvent().withEventData({
  action: 'add to basket',
  non_interaction: true,
})

export const moreInfoEvent = SelectContentEvent().withEventData({
  action: 'view more information',
  non_interaction: true,
})
